module.exports = __webpack_public_path__ + "img/financing.2a75e074.png";